var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllVideoOn = function SvgAllVideoOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all_video_on_svg__st0",
    d: "m18.5 7.7-3.2 1.9v-1c-.1-.3-.3-.6-.6-.6h-9c-.4 0-.6.3-.6.6v6.8c0 .3.2.6.5.6h9c.3 0 .5-.3.5-.6v-1l3.2 1.9c.2.1.4-.1.4-.3V8c.2-.2 0-.4-.2-.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all_video_on_svg__st0",
    d: "M12 1.5c5.8 0 10.5 4.7 10.5 10.5S17.8 22.5 12 22.5 1.5 17.8 1.5 12 6.2 1.5 12 1.5M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
  })));
};
export default SvgAllVideoOn;